import { getDefaultStore } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const TELEGRAM_BACK_URL_KEY = "FCTelegramConnectBackUrl" as const;
export const TELEGRAM_CONNECT_PATH = "/telegram/connect" as const;

export const telegramBackUrlAtom = atomWithStorage<{
	to: typeof TELEGRAM_CONNECT_PATH;
	search: { token: string };
} | null>(
	TELEGRAM_BACK_URL_KEY,
	null,
	createJSONStorage(() => sessionStorage),
);
telegramBackUrlAtom.debugLabel = "telegramBackUrlAtom";

/**
 * Remembers where to send the user back to once they are logged in, so the
 * token coming from the Telegram bot link survives any redirect to /login.
 */
export function rememberTelegramConnectTarget(token?: string | null) {
	if (!token) {
		return false;
	}

	getDefaultStore().set(telegramBackUrlAtom, {
		to: TELEGRAM_CONNECT_PATH,
		search: { token },
	});

	return true;
}
